import Fetch from './apiConfig/apiConfig';
import queryString from 'query-string';
export interface IGetTradingGroupsParams {
  [key: string]: any;
  categoryId: number;
}
export interface IGetTradingGroupsResponse {
  tradingGroups: string[];
}

export const getTradingGroups = async (params: IGetTradingGroupsParams): Promise<string[]> => {
  const axios = await Fetch();
  const { data } = await axios.get<IGetTradingGroupsResponse>(`products/trading-groups?${queryString.stringify(params)}`);

  return data.tradingGroups;
};
